const en = {
  imprint: "Imprint",
  imprintUrl: "https://molit.eu/en/imprint/",
  noSecret: "The page cannot be shown, because the request originated from an unautherized system.",
  save: "Confirm data donation",
  continue: "Continue",
  status: "Status",
  noEntriesFound: "No Entries Found",
  patientForm: {
    patientDetails: "Patient Details",
    patientAddress: "Patient Address ",
    firstname: "First Name",
    lastname: "Last Name",
    birthname: "Birth Name",
    birthdate: "Birthdate",
    gender: {
      gender: "Gender",
      male:"Male",
      female: "Female",
      divers: "Divers",
      unknown: "Unknown",
      other: "Other"
    },
    street: "Street Name",
    houseNumber: "House Number",
    postCode: "Post Code",
    town: "Town",
    insuranceNumber: "Insurance Number",
    caseId: "Case Id",
    patientId: "Patient ID",
    organisation: "Organisation",
    placeholder: {
      select: "Please select"
    },
    required: "Please select an answer."
  },
  message: {
    error: {
      e400: "The organization could not be verified by the server.",
      e401: "You are not authorised to carry out this action",
      e403: "You are not authorized to perform this operation.",
      e404: "Server is not available, please try again later.",
      e409: "Another patient with this case ID or patient ID has already been created. Please check your entries.",
      e4xx: "An error occurred, please try again later.",
      e5xx: "An internal server error has occurred."
    },
    contactSupport: "Contact support",
    birthdate_in_future: "The given birthdate is in the future",
    success: "Save was successful!",
    savingInProgress: "Saving...",
    confirmImplicationSave: "By clicking on \"Confirm data donation\" you confirm that the patient has agreed with his signature to use his data for research purposes as stated.",
    confirmImplicationSaveRequired: "Confirmation of the patient's consent to data donation is required."
  },
  consentQuestion: {
    consentTitle: "Consent to the use of patient data for medical research purposes",
    datenspende: "Collection, processing and scientific use of my patient data as described in the Patient Information",
    kontaktaufnahme_Zusatzbefunde: "Possibility of renewed contact (additional medical findings)",
    kontaktaufnahme_wissenschaftlich: "Possibility to be contacted again (scientific questions)",
    datenspendeDetail: "This includes </br> 1.) the processing and use of my patient data for medical research Administration of the name and other directly identifying data (coding) as described in the Patient Information (see points 1.1 and 1.2). </br> 2.) the scientific analysis and use of my coded patient data by third parties such as other clinics, universities, institutes, research companies; this may also include transfer for research projects abroad if European data protection law applies in these countries or the European Commission has confirmed an adequate level of data protection. I will not be involved in any commercial benefit from the research. Furthermore, prior to disclosure to researchers outside my treating institution, the internal identifier will be further replaced by a new combination of characters. </br> 3) the possibility of merging my patient data with data in databases of other research partners. The prerequisite is that I have also agreed to this use with the relevant research partners. </br> I consent to the collection, processing, storage and scientific use of my patient data as described in points (1) to (3) of the declaration of consent and point 1 of the patient information.",
    kontaktaufnahme_Zusatzbefunde_Detail: "I agree that I may be contacted again to be informed about additional medical findings (see point 2.2 of the patient information).",
    kontaktaufnahme_wissenschaftlich_Detail: "I agree that I may be contacted again to provide additional information relevant to scientific questions, to be informed about new research projects/studies, if necessary, and/or to obtain my consent to link my patient data with medical information from other databases (see point 2.1 of the patient information).",
    showMore: "show more",
    showLess: "show less",
    yes: "Yes",
    no: "No"
  }
};

export default en;
